import { render } from "./ASWOSearch.vue?vue&type=template&id=3da9870b&scoped=true"
import script from "./ASWOSearch.vue?vue&type=script&lang=js"
export * from "./ASWOSearch.vue?vue&type=script&lang=js"

import "./ASWOSearch.vue?vue&type=style&index=0&id=3da9870b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WONHAP\\Websites\\aswo-api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da9870b"]])

export default __exports__